"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var regions_unavailable_1 = require("@launchedla/hb-shared/dist/regions-unavailable");
var React = __importStar(require("react"));
var react_1 = require("react");
var react_query_1 = require("react-query");
var fetch_user_geolocation_1 = require("../../../utils/fetch-user-geolocation");
var format_price_1 = __importDefault(require("../../../utils/format-price"));
var app_1 = require("../../bundler/app");
var variant_details_modal_1 = __importDefault(require("../../bundler/components/variant-details-modal"));
var variant_quantity_picker_1 = __importDefault(require("../../bundler/components/variant-quantity-picker"));
var localization_1 = require("../../checkout/localization");
var app_2 = require("../app");
var products_filter_1 = require("../components/products-filter");
/** @param userCountryCode Uppercase country code that we believe the user is in. e.g. "US" or "CA" */
var isProductAvailableInRegion = function (productTags, userCountryCode) {
    var e_1, _a;
    var unavailableRegions = (0, regions_unavailable_1.getUnavailableRegions)(productTags) || [];
    try {
        for (var unavailableRegions_1 = __values(unavailableRegions), unavailableRegions_1_1 = unavailableRegions_1.next(); !unavailableRegions_1_1.done; unavailableRegions_1_1 = unavailableRegions_1.next()) {
            var region = unavailableRegions_1_1.value;
            if (userCountryCode === region.countryCode && !region.provinceCode)
                return false;
            // can add a check for an unavailable provinceCode here when needed
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (unavailableRegions_1_1 && !unavailableRegions_1_1.done && (_a = unavailableRegions_1.return)) _a.call(unavailableRegions_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
};
var productFilterFn = function (_a) {
    var userCountryCode = _a.userCountryCode;
    return function (_a) {
        var product = _a.product, variant = _a.variant;
        var tags = product.tags; // TODO: this is not a Shopify.Product
        if (tags && userCountryCode && !isProductAvailableInRegion(tags, userCountryCode))
            return false;
        return variant.available;
    };
};
var SelectProducts = function () {
    var _a, _b;
    var _c = (0, react_1.useContext)(app_2.AppContext), addChoice = _c.addChoice, availableChoices = _c.availableChoices, minSelectionTotal = _c.minSelectionTotal, selectedChoices = _c.selectedChoices, subChoice = _c.subChoice, setLeftSideImage = _c.setLeftSideImage, existingBundle = _c.existingBundle;
    // hide out-of-stock items for now
    var hideOOSItems = true;
    (0, react_1.useEffect)(function () {
        var _a;
        setLeftSideImage((_a = window.essentialsBundlerApp) === null || _a === void 0 ? void 0 : _a.settings.selectProducts.leftSideImage);
    }, []);
    if (!minSelectionTotal) {
        return React.createElement(React.Fragment, null);
    }
    // Determine the user's country, preferring to check the existing bundle's address if present, and falling back to checking the customer's IP address
    var existingBundleCountry = (_a = existingBundle === null || existingBundle === void 0 ? void 0 : existingBundle.address) === null || _a === void 0 ? void 0 : _a.country;
    var userGeolocationQuery = (0, react_query_1.useQuery)([fetch_user_geolocation_1.getOrFetchAndUpdateCountryCodeByIpCookieUseQueryKey], fetch_user_geolocation_1.getOrFetchAndUpdateCountryCodeByIpCookie, { enabled: !existingBundleCountry });
    var inStockAvailableChoices = (0, react_1.useMemo)(function () {
        // Check the existing bundle's address if present
        if (existingBundleCountry) {
            if ((0, localization_1.isCanadianAddressCountry)(existingBundleCountry)) {
                return availableChoices.filter(productFilterFn({ userCountryCode: 'CA' }));
            }
            // If the bundle isn't shipping to Canada, assume that it's shipping to the US
            return availableChoices.filter(productFilterFn({ userCountryCode: 'US' }));
        }
        // Fall back to checking the customer's IP address, displaying no products until we know it
        if (!userGeolocationQuery.isSuccess)
            return [];
        return availableChoices.filter(productFilterFn({ userCountryCode: userGeolocationQuery.data.countryCode }));
    }, [availableChoices, userGeolocationQuery.isSuccess, (_b = userGeolocationQuery.data) === null || _b === void 0 ? void 0 : _b.countryCode, existingBundleCountry]);
    var _d = __read((0, react_1.useState)(null), 2), openModalProductVariant = _d[0], setOpenModalProductVariant = _d[1];
    var handleOpenModalClick = function (_a) {
        var product = _a.product, variant = _a.variant;
        return function () {
            setOpenModalProductVariant([product, variant]);
        };
    };
    var handleCloseModalClick = function () { return setOpenModalProductVariant(null); };
    var handleIncreaseClick = function (incoming) { return function () {
        var chosenProduct = availableChoices.find(function (availChoice) {
            return availChoice.variant.id === incoming.id;
        });
        addChoice(chosenProduct);
    }; };
    var handleDecreaseClick = function (incoming) { return function () {
        var chosenProduct = availableChoices.find(function (availChoice) {
            return availChoice.variant.id === incoming.id;
        });
        subChoice(chosenProduct);
    }; };
    var _e = (0, products_filter_1.initFilters)(hideOOSItems ? inStockAvailableChoices : availableChoices), filteredProducts = _e.filteredProducts, renderFilters = _e.renderFilters, activeFilter = _e.activeFilter;
    var sortedAddOns = (0, react_1.useMemo)(function () {
        var selAddOnsIds = selectedChoices.map(function (v) { return v.variant.id; });
        return filteredProducts.sort(function (choice1, choice2) {
            // if we have already selected a, move it up
            if (selAddOnsIds.includes(choice1.variant.id))
                return -1;
            // if we have already selected b, move it up
            if (selAddOnsIds.includes(choice2.variant.id))
                return 1;
            // if a's product is tagged to show up first, move it up
            if (choice1.product.tags.includes(app_1.sortFirstTag))
                return -1;
            // if b's product is tagged to show up first, move it up
            if (choice2.product.tags.includes(app_1.sortFirstTag))
                return 1;
            // else move nothing
            return 0;
        });
    }, [activeFilter, filteredProducts]); // re-sort when the active filter changes and when the products are finished loading
    return (React.createElement("div", { className: 'padding-horizontal-4 medium-padding-horizontal-6' },
        renderFilters(),
        React.createElement("div", { className: 'grid-x small-up-2 medium-up-3 large-up-4 grid-margin-x grid-margin-y' }, sortedAddOns.map(function (_a, i) {
            var product = _a.product, variant = _a.variant;
            var numSelected = selectedChoices.filter(function (c) { return c.product.id === product.id && c.variant.id === variant.id; }).reduce(function (sum, c) { return sum + c.quantity; }, 0);
            return (React.createElement(variant_quantity_picker_1.default, { key: i, numSelected: numSelected, priceLine: (0, format_price_1.default)(variant.price), compareAtPrice: variant.compare_at_price ? (0, format_price_1.default)(variant.compare_at_price) : undefined, product: product, variant: variant, setModalChoice: handleOpenModalClick({ product: product, variant: variant }), enableDetailsModal: true, handleIncClick: handleIncreaseClick, handleDecClick: handleDecreaseClick }));
        })),
        openModalProductVariant && (React.createElement(variant_details_modal_1.default, { productVariantArr: openModalProductVariant, handleCloseModalClick: handleCloseModalClick, isDiscount: true, handleIncreaseClick: handleIncreaseClick }))));
};
exports.default = SelectProducts;
